<div class="row max-row-height" *ngFor="let candidate of candidateProfileInfos">
    <div class="col-12" [ngClass]="candidate.accountId === selectedCandidate ? 'selected': null">
        <a role="button" [routerLink]="" (click)="onCandidateSelected(candidate.accountId)">
            <div class="container-fluid">
                <div class="row candidate-list">
                    <div class="col-5 pr-0 pl-0">
                        <div class="candidate-list-image">
                            <img class="img-fluid" [src]="getPhotoPath(candidate)" alt="">
                        </div>
                    </div>
                    <div class="col-6 pr-0 pl-4">
                        <div class="candidate-list-details">
                            <div class="candidate-list-info">
                                <div class="candidate-list-title">
                                    <h5 class="mb-0">{{candidate.name}}</h5>
                                </div>
                                <div class="candidate-list-option">
                                    <ul class="list-unstyled">
                                        <li>
                                            {{candidate.title}}
                                            <br/>
                                            <b><span class="mb-0 progress-status">{{candidate.progressStatus}}</span></b>
                                        </li>
                                        <li>
                                            <a role="button" [routerLink]="" (click)="onViewProfileClicked(candidate.resumeId)">View Profile</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </a>
    </div>
</div>
